var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.partsStatusScreen.show && !_vm.purchaseOrderScreen.show
      ? _c(
          "article",
          { staticClass: "box p-0 m-0" },
          [
            _c("div", { staticClass: "columns p-0 m-0 pt-3 sticky-heading" }, [
              _vm._m(0),
              _c("div", { staticClass: "column p-0 m-0 is-6" }, [
                _c(
                  "div",
                  { staticClass: "is-flex is-flex-direction-row-reverse" },
                  [
                    _c("div", { staticClass: "field" }, [
                      _vm.userPartsCheckPermission() &&
                      _vm.value.parts.filter(
                        (p) =>
                          p.deleted === false &&
                          !p.isNew &&
                          (p.partStatus == "Exp" || p.partStatus == "Imp")
                      ).length > 0
                        ? _c(
                            "div",
                            {
                              staticClass: "button is-primary is-outlined mr-3",
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("downloadPartsCheckPrice")
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "material-symbols-rounded mr-2",
                                },
                                [_vm._v(" currency_exchange ")]
                              ),
                              _c("span", [_vm._v("Sync")]),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
              ]),
            ]),
            _c("quote-parts-control-not-ordered", {
              attrs: {
                value: _vm.value,
                "snapshot-diff": _vm.snapshotDiff,
                "parts-check-settings": _vm.partsCheckSettings,
                "unordered-parts": _vm.unorderedParts,
              },
              on: {
                newPurchaseOrder: (itemsToPurchase, key) =>
                  _vm.handleCreateNewPurchaseOrder(itemsToPurchase, key),
                goToPriceParts: _vm.goToPriceParts,
                goToPartsCheck: _vm.goToPartsCheck,
              },
            }),
            _vm._m(1),
            _vm._l(_vm.purchaseOrders, function (purchaseOrder, index) {
              return _c(
                "div",
                {
                  key: purchaseOrder.purchaseOrderId,
                  staticClass: "glow",
                  class: {
                    active: purchaseOrder.purchaseOrderId == _vm.newPoId,
                  },
                  attrs: { id: purchaseOrder.purchaseOrderId },
                },
                [
                  _c("quote-parts-control-ordered", {
                    attrs: {
                      value: _vm.value,
                      id:
                        index +
                        "-parts-control-ordered-parts-group" +
                        purchaseOrder.purchaseOrderId,
                      "purchase-order": purchaseOrder,
                    },
                    on: {
                      printReturnOrder: _vm.printReturnOrder,
                      handleReturnOrder: (orderReceipt, purchaseOrder) =>
                        _vm.handleReturnOrder(orderReceipt, purchaseOrder),
                      handleEditOrder: (orderReceipt, purchaseOrder) =>
                        _vm.handleEditOrder(orderReceipt, purchaseOrder),
                      goToPartsCheck: _vm.goToPartsCheck,
                      changeItemStatus: _vm.changeItemStatus,
                    },
                  }),
                ],
                1
              )
            }),
            _vm.purchaseOrders.length === 0
              ? _c("div", { staticClass: "p-3" }, [
                  _c("div", { staticClass: "notification is-grey-dark" }, [
                    _vm._v(" No ordered parts "),
                  ]),
                ])
              : _vm._e(),
          ],
          2
        )
      : _c(
          "article",
          { staticClass: "box p-0 m-0" },
          [
            _vm.purchaseOrderScreen.show == _vm.partsControlEnums.newPo.key
              ? _c("parts-control-new-purchase-order", {
                  attrs: {
                    "quote-id": _vm.value.quoteId,
                    quote: _vm.value,
                    "quote-no": _vm.value.quoteNo,
                    "insurer-id": _vm.value.insurerId,
                    "customer-id": _vm.value.customerId,
                    "unordered-parts": _vm.purchaseOrderScreen.itemsToPurchase,
                  },
                  on: {
                    close: (message, refreshQuote = false, purchaseOrderId) =>
                      _vm.handleOnClose(message, refreshQuote, purchaseOrderId),
                  },
                })
              : _vm._e(),
            _vm.purchaseOrderScreen.show ==
            _vm.partsControlEnums.manualQuote.key
              ? _c("parts-control-manual-quote", {
                  attrs: {
                    quote: _vm.value,
                    "unordered-parts": _vm.purchaseOrderScreen.itemsToPurchase,
                  },
                  on: {
                    updateUnorderedPartStatus: _vm.updateUnorderedPartStatus,
                    close: (message, refreshQuote = false, purchaseOrderId) =>
                      _vm.handleOnClose(message, refreshQuote, purchaseOrderId),
                  },
                })
              : _vm._e(),
            _vm.partsStatusScreen.status == _vm.partsControlEnums.receive.key
              ? _c("parts-control-recieve-parts", {
                  attrs: {
                    "purchase-order": _vm.partsStatusScreen.purchaseOrder,
                    "order-receipt": _vm.partsStatusScreen.orderReceipt,
                    "selected-items": _vm.partsStatusScreen.selectedItems,
                    "is-editable": _vm.permissions.hasEdit,
                  },
                  on: {
                    close: (message, refreshQuote = false) =>
                      _vm.handleOnClose(message, refreshQuote),
                  },
                })
              : _vm._e(),
            _vm.partsStatusScreen.status == _vm.partsControlEnums.cancel.key
              ? _c("parts-control-cancel-parts", {
                  attrs: {
                    "purchase-order": _vm.partsStatusScreen.purchaseOrder,
                    "selected-items": _vm.partsStatusScreen.selectedItems,
                  },
                  on: {
                    close: (message, refreshQuote = false) =>
                      _vm.handleOnClose(message, refreshQuote),
                  },
                })
              : _vm._e(),
            _vm.partsStatusScreen.status == _vm.partsControlEnums.return.key
              ? _c("parts-control-return-parts", {
                  attrs: {
                    "purchase-order": _vm.partsStatusScreen.purchaseOrder,
                    "order-receipt": _vm.partsStatusScreen.orderReceipt,
                    "selected-items": _vm.partsStatusScreen.selectedItems,
                  },
                  on: {
                    printReturnOrder: _vm.printReturnOrder,
                    close: (message, refreshQuote = false) =>
                      _vm.handleOnClose(message, refreshQuote),
                  },
                })
              : _vm._e(),
          ],
          1
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column p-0 m-0 is-6" }, [
      _c("p", { staticClass: "title px-3" }, [_vm._v("Parts Control")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "columns p-0 m-0 sticky-heading",
        staticStyle: { "margin-top": "12px !important" },
      },
      [
        _c("div", { staticClass: "column p-0 m-0 is-full" }, [
          _c("p", { staticClass: "title px-3" }, [
            _vm._v(" Parts Control - Ordered "),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }